import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: 16px;
`

export const Label = styled.div`
  color: #14171f;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 32px;

  & > * {
    width: 300px;
  }
`

export const AddOptionButton = styled.button`
  display: flex;
  align-items: center;
  color: #14171f;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  width: 156px;

  background: transparent;

  border: none;

  color: #4d4be7;

  cursor: pointer;

  padding: 0px;
`

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  & > :first-child {
    flex: 1;
  }
`

export const Selected = styled.div`
  color: var(--foreground-neutral, #14171f);

  line-height: 20px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`

export const ButtonContainer = styled.button`
  cursor: pointer;
  border: none;
  outline: none;

  width: 36px;
  height: 36px;

  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;

  border-radius: 6px;
  border: 1px solid var(--border-neutral-faded, #dfe2ea);
  background: var(--background-elevation-base, #fff);
`

export const RowTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const ImportResponsesButton = styled.button`
  display: flex;
  align-items: center;
  color: #14171f;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  background: transparent;

  border: none;

  color: #4d4be7;

  cursor: pointer;

  padding: 0px;
`
